import checkPermission from '@/utils/permission';

export const applicationsDetail = () =>  checkPermission(['applicationsDetail']);
